import {
  FINANCIAL_INSTITUTION_IDS_LIST,
  type FinancialInstitutionId,
} from "@/constants/financialInstitutions";

const STORAGE_KEY = "bic_current_financial_institution";

const isFinancialInstitutionId = (
  value: string,
): value is FinancialInstitutionId =>
  (FINANCIAL_INSTITUTION_IDS_LIST as readonly string[]).includes(value);

export const saveCurrentFinancialInstitution = (
  financialInstitution: FinancialInstitutionId,
): void => {
  localStorage.setItem(STORAGE_KEY, financialInstitution);
};

export const loadCurrentFinancialInstitution =
  (): FinancialInstitutionId | null => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null || !isFinancialInstitutionId(raw)) {
      return null;
    }
    return raw;
  };

export const clearCurrentFinancialInstitution = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
